<template>
  <b-col>
    <HotelInfo :result="result" :key="result.id" />
    <b-row v-if="showPrices">
      <b-col md="12">
        <div class="table-responsive">
          <h6 class="package-title" v-translate>Price details</h6>
          <table class="table table-sm text-center">
            <thead class="t-head thead-light text-center">
              <tr>
                <td v-translate>Room</td>
                <td></td>
                <td v-translate>Meal</td>
                <td v-translate>Booking price</td>
                <td v-translate>Sale</td>
                <td v-translate>Availability</td>
              </tr>
            </thead>
            <tbody>
              <template v-for="category in result.categories">
                <Category
                  :category="category"
                  :currency="currency"
                  :showCollapse="false"
                  :showBook="false"
                  :fees="fees"
                  :starRating="result.stars"
                  :key="'categoryInfo' + category.id" />
              </template>
            </tbody>
          </table>
          <!-- <p class="package-warning" v-translate>*Attention! The reduced price is valid subject to availability!</p> -->
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import HotelInfo from '@/app/private/shared/components/hotel_info'
import Category from '@/app/private/shared/components/category_result'

export default {
  name: 'detailedInfo',
  props: {
    result: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    showPrices: {
      type: Boolean,
      required: false,
      default: true
    },
    fees: {
      type: Object,
      default: () => { return {} }
    }
  },
  components: { HotelInfo, Category }
}
</script>
